module.exports = __webpack_public_path__ + "Roboto-ThinItalic.588293290e86dad97fcf.woff";


//////////////////
// WEBPACK FOOTER
// /jenkins/jenkins/workspace/apppronosticos_install_s3_dev/~/roboto-fontface/fonts/Roboto/Roboto-ThinItalic.woff
// module id = ../../../../roboto-fontface/fonts/Roboto/Roboto-ThinItalic.woff
// module chunks = 5